import { addDevVars } from "@/dev/initDev.ts";
import { atomWithLocalStorage } from "@/utils/jotai/atomStorage.ts";
import { atom } from "jotai";

export const debugBarVisibleAtom = atomWithLocalStorage<boolean>("debugBarVisible", false);

/**
 * The user can execute `localStorage.forceDebug = "true"` in the browser console to force the debug bar to be visible.
 * Can also hide it with `false`.
 */
export const forceDebugAtom = atomWithLocalStorage<boolean | undefined>("forceDebug", undefined);

export const hasDebugBarAtom = atom((get) => get(forceDebugAtom) ?? !import.meta.env.PROD);

addDevVars({ hasDebugBarAtom });
